var exports = {
  "k": "x93eb46d8--845193--container",
  "i": "x93eb46d8--845193--wrapper",
};

module.exports = exports;
